export const aboutData = {
    title: "About Me",
    description1: "My name is Alex. I'm a third-year studying Computer Science and Data Science at UC Berkeley.",
    description2: "I'm passionate about full-stack development and am enthusiastic about making a positive impact using technology.",
    description3: "I love talking about philosophy, self-development, and lifting!",
    image: "src/assets/jpg/IMG_8676.JPG"
}